<template>
  <avl-modal :is-shown="gameIsCreated">
    <h1 class="g-mn__title">
      The game is
      <span
        class="g-mn__text-locked"
        :class="{ 'g-mn__text-locked--locked': getGameIsLocked }"
        v-tooltip="getGameIsLocked ? 'Nobody can join' : 'Joining is allowed'"
      >
        {{ getGameIsLocked ? 'Locked' : 'Unlocked' }}
      </span>
    </h1>

    <template v-if="getIAmCreator">
      <div class="g-mn__row">
        <el-checkbox v-model="hasMorganaAndPercival" label="Morgana & Percival" />

        <div class="g-mn__player-avatar-wrapper">
          <avl-player-avatar class="g-mn__player-avatar" id="MORGANA" />
        </div>

        <div class="g-mn__player-avatar-wrapper g-mn__player-avatar-wrapper--shifted-left">
          <avl-player-avatar class="g-mn__player-avatar" id="PERCIVAL" />
        </div>
      </div>

      <div class="g-mn__row">
        <el-checkbox v-model="hasMordred" label="Mordred" />

        <div class="g-mn__player-avatar-wrapper">
          <avl-player-avatar class="g-mn__player-avatar" id="MORDRED" />
        </div>
      </div>

      <div class="g-mn__row">
        <el-checkbox v-model="hasOberon" label="Oberon" />

        <div class="g-mn__player-avatar-wrapper">
          <avl-player-avatar class="g-mn__player-avatar" id="OBERON" />
        </div>
      </div>

      <hr class="g-mn__separator" />

      <div class="g-mn__row">
        <el-checkbox v-model="votesAreAnonymous" label="Anonymous Approve / Rejects" />
      </div>

      <div class="g-mn__row">
        <el-checkbox v-model="goodGuysAreAllowedToFail" label="Good Guys Can Fail Quests" />
      </div>

      <div class="g-mn__row" v-tooltip="getGameIsLocked ? undefined : 'Lock the game first'">
        <el-button class="g-mn__button" @click.native="onGameStart" :disabled="!getGameIsLocked">
          Start Game
        </el-button>
      </div>

      <div class="g-mn__row" v-if="getGameIsLocked">
        <el-button
          class="g-mn__button"
          @click.native="$store.dispatch('game/unlockGame', $route.params.id)"
        >
          Unlock Game
        </el-button>
      </div>

      <div class="g-mn__row" v-else>
        <el-button
          class="g-mn__button"
          @click.native="$store.dispatch('game/lockGame', $route.params.id)"
        >
          Lock Game
        </el-button>
      </div>
    </template>

    <div class="g-mn__row">
      <el-button
        class="g-mn__button"
        @click.native="$router.push({ name: 'lobby' })"
        :disabled="getGameIsLocked"
      >
        Leave Game
      </el-button>
    </div>
  </avl-modal>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data: () => ({
      menuIsShown: true,
      hasMordred: false,
      hasMorganaAndPercival: false,
      hasOberon: false,
      votesAreAnonymous: false,
      goodGuysAreAllowedToFail: false,
    }),
    computed: {
      ...mapGetters(['getIAmCreator', 'getGameIsLocked', 'gameIsCreated']),
    },
    methods: {
      onGameStart() {
        this.$store.dispatch('game/startGame', {
          gameId: this.$route.params.id,
          hasMordred: this.hasMordred,
          hasMorganaAndPercival: this.hasMorganaAndPercival,
          hasOberon: this.hasOberon,
          votesAreAnonymous: this.votesAreAnonymous,
          goodGuysAreAllowedToFail: this.goodGuysAreAllowedToFail,
        });
      },
    },
  };
</script>

<style lang="scss">
  .g-mn {
    &__row {
      display: flex;
      align-items: center;
      user-select: none;
      text-align: left;
      padding: 0 24px;
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &__player-avatar-wrapper {
      line-height: 0;
      margin-left: 4px;
      height: 24px;
      width: 24px;

      &--shifted-left {
        border-color: white;
        border-radius: 50%;
        margin-left: 0;
        transform: translateX(-50%);
      }
    }

    &__separator {
      height: 1px;
      width: 100px;
      margin: 12px auto;
      background: lightgray;
      border: none;
    }

    &__player-avatar {
      padding: 0 !important;

      .player-avatar__container {
        border: 1px solid transparent;
        border-radius: 50%;
      }
    }

    &__player-avatar-wrapper--shifted-left .player-avatar__container {
      border-color: white;
    }

    &__title {
      margin: 0 0 24px;
    }

    &__text-locked {
      color: $green;

      &--locked {
        color: $red;
      }
    }

    &__button {
      display: inline-block;
      width: 100%;
    }
  }
</style>
